<template>
  <a-card :bordered="false" :title="title">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="姓名" v-bind="searchItemLayout">
            <a-input v-model="queryParams.name" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="手机号" v-bind="searchItemLayout">
            <a-input v-model="queryParams.mobile" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="店名" v-bind="searchItemLayout">
            <a-input v-model="queryParams.shopName" placeholder="请输入"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="统计范围" v-bind="searchItemLayout">
            <a-range-picker
              @change="onDateChange"
              :value="queryDate"
              format="YYYY-MM-DD"
              style="width: 100%"/>
          </a-form-item>
          <a-form-item style="margin-left:10%;">
            <a-button type="primary" @click="onSearch">查询</a-button>
            <a-button style="margin: 0 10px" @click="onExport">导出</a-button>
            <a-button @click="toStatement">查看已生成报表</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',paddingLeft:'0px'}">
      <custom-page-table
        ref="table"
        rowKey="staffId"
        :queryParams="queryParams"
        :columns="columns"
        :requestPromise="loadPromise"
      >
        <span slot="index" slot-scope="rowItem">
          {{ rowItem.index + 1 }}
        </span>
        <span slot="salesAmount" slot-scope="rowItem">
          ￥{{ rowItem.record.salesAmount }}
        </span>
        <span slot="incomeCommission" slot-scope="rowItem">
          ￥{{ rowItem.record.incomeCommission }}
        </span>
        <span slot="action" slot-scope="rowItem">
          <a @click="showModal(rowItem.record.staffId)">佣金记录</a>
        </span>
      </custom-page-table>
    </a-card>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import { addDate } from '@/utils/common'

export default {
  name: 'ClerkPerformance',
  mixins: [searchForm],
  data() {
    return {
      title: this.$route.query.storeName + ' > 店员业绩',
      queryParams: {},
      commissionParams: {},
      storeId: this.$route.query.storeId,
      loadPromise: params => this.getResultsList(params),
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '姓名',
          dataIndex: 'staffName'
        },
        {
          title: '店名',
          dataIndex: 'shopName'
          // scopedSlots: { customRender: 'capitalFlows' }
        },
        {
          title: '手机号',
          dataIndex: 'mobile'
        },
        {
          title: '销售额',
          dataIndex: 'salesAmount',
          scopedSlots: { customRender: 'salesAmount' },
          sorter: (a, b) => a.salesAmount - b.salesAmount
        },
        {
          title: '佣金收入',
          dataIndex: 'incomeCommission',
          scopedSlots: { customRender: 'incomeCommission' },
          sorter: (a, b) => a.incomeCommission - b.incomeCommission
        },
        {
          title: '加入时间',
          dataIndex: 'createTime',
          sorter: (a, b) => this.timer(a.createTime) - this.timer(b.createTime)
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      selectedDate: '',
      visible: false,
      queryDate: this.getDateHelper().getDateMoments(addDate(new Date(), -29), new Date())
    }
  },
  mounted() {
  },
  methods: {
    showModal(id) {
      this.openNewPage('CommissionRecord', { staffId: id })
    },
    onExport() {
      let params = {
        // createTimeSort:1,
        // salesAmountSort:1,
        incomeCommissionSort: 2,
        storeId: this.storeId,
        startDate: this.queryParams.startDate,
        endDate: this.queryParams.endDate,
        name: this.queryParams.name,
        shopName: this.queryParams.shopName,
        mobile: this.queryParams.mobile
      }
      this.getHttpServices().getUserService().post('store/storeMemberPerformanceExport', params)
        .then(res => {
          this.$message.success('导出成功')
        })
        .catch(reason => {
          this.$message.error('导出失败')
          this.getLogUtils().logWithTag(reason)
        })
    },
    handleCancel() {
      this.visible = false
    },
    timer(data) {
      let thisTime = data
      thisTime = thisTime.replace(/-/g, '/')
      let time = new Date(thisTime)
      time = time.getTime()
      return time
    },
    onSearch() {
      this.$refs.table.refresh(true)
    },
    onDateChange(dates, dateStrArr) {
      this.queryDate = dates
      this.queryParams.startDate = dateStrArr[0]
      this.queryParams.endDate = dateStrArr[1]
    },
    toStatement() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    getResultsList(params) {
      this.getLogUtils().logWithTag('params', params)
      let list = {
        limitDto: {
          pageNum: params.limitDto.pageNum,
          pageSize: params.limitDto.pageSize
        },
        // createTimeSort:1,
        // salesAmountSort:1,
        incomeCommissionSort: 2,
        storeId: this.storeId,
        startDate: this.queryParams.startDate,
        endDate: this.queryParams.endDate,
        name: this.queryParams.name,
        shopName: this.queryParams.shopName,
        mobile: this.queryParams.mobile
      }
      return this.getHttpServices().getUserService().post('store/queryBackgroundPerformanceList', list)
    }
  }
}
</script>

<style scoped>

</style>